import React from 'react';
import './OnboardingButtons.css'; // Import the CSS file

const Button = ({ type, onClick, children, disabled }) => {
  return (
    <button className={type} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

const OnboardingButtons = ({ currentStep, onBackClick, onNextClick, onSubmit,isSubmitDisabled }) => {

  return (
    <div className="buttons">
      {currentStep > 0 && (
        <div className="back-button">
          <Button type="back" onClick={onBackClick} >
            Back
          </Button>
        </div>
      )}
      <div className="next-button">
        {currentStep === 2 ? (
          <Button type="submit" onClick={onSubmit} disabled = {isSubmitDisabled}>
            Submit
          </Button>
        ) : (
          <Button type="next" onClick={onNextClick}>
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

export default OnboardingButtons;
